import { atom } from "recoil";

const AtomBreadcrumb2 = atom<string>({
  key: "AtomBreadcrumb",
  default: "dashboard"
});
export default AtomBreadcrumb2;
